import { getEnvData } from '@src/utils';
import axios from 'axios';
export type { AxiosRequestConfig as RequestConfig } from 'axios';

const ENV_DATA = getEnvData();

export const userBaseURL = ENV_DATA.API_BASE_URL;
export const businessBaseURL = ENV_DATA.BUSINESS_API_BASE_URL;
export const adminBaseURL = ENV_DATA.ADMIN_API_BASE_URL;

export const BusinessAxiosConfig = axios.create({
  baseURL: businessBaseURL,
  timeout: 60000,
  showToastOnError: true,
  headers: {
    ApplicationID: ENV_DATA.API_APPLICATION_ID,
    SecretKey: ENV_DATA.API_SECRET_KEY
  }
});

export const UserAxiosConfig = axios.create({
  baseURL: userBaseURL,
  timeout: 60000,
  showToastOnError: true
});

export const AdminAxiosConfig = axios.create({
  baseURL: adminBaseURL,
  timeout: 60000,
  showToastOnError: true,
  headers: {
    ApplicationID: ENV_DATA.ADMIN_API_APPLICATION_ID,
    SecretKey: ENV_DATA.ADMIN_API_SECRET_KEY
  }
});

export const addTokenHeader = (token: string, type?: 'json' | 'formData') => {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': type === 'formData' ? 'multipart/form-data' : 'application/json',
      ApplicationID: ENV_DATA.API_APPLICATION_ID,
      SecretKey: ENV_DATA.API_SECRET_KEY,
      /**
       * 1 = web
       */
      DeviceType: '1'
    }
  };
};

export const addAdminTokenHeader = (token: string, type?: 'json' | 'formData') => {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': type === 'formData' ? 'multipart/form-data' : 'application/json',
      ApplicationID: ENV_DATA.ADMIN_API_APPLICATION_ID,
      ApplicationSecret: ENV_DATA.ADMIN_API_SECRET_KEY,
      SessionToken: ` ${token}`,
      /**
       * 1 = web
       */
      DeviceType: '1'
    }
  };
};
